import styled from 'styled-components'

export const Loading = styled.div`
  background: white;
  left: 50%;
  top: 160px;
  width: 122px;
  height: 45px;
  margin-left: -61px;
  position: absolute;
  border-radius: 50px;
  text-align: center;
  vertical-align: middle;
`

export const OneAuthWrapper = styled.div`
  position: relative;
`
